import { render, staticRenderFns } from "./CurriculumComponent.vue?vue&type=template&id=bc45f0b6&scoped=true"
import script from "./CurriculumComponent.vue?vue&type=script&lang=js"
export * from "./CurriculumComponent.vue?vue&type=script&lang=js"
import style0 from "./CurriculumComponent.vue?vue&type=style&index=0&id=bc45f0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45f0b6",
  null
  
)

export default component.exports